import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_update_role",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-750px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"btn btn-icon btn-sm btn-active-icon-primary\" data-kt-roles-modal-action=\"close\" data-bs-dismiss=\"modal\"><span class=\"svg-icon svg-icon-1\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><rect opacity=\"0.5\" x=\"6\" y=\"17.3137\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(-45 6 17.3137)\" fill=\"black\"></rect><rect x=\"7.41422\" y=\"6\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(45 7.41422 6)\" fill=\"black\"></rect></svg></span></div>", 1)
const _hoisted_7 = { class: "modal-body scroll-y mx-5 my-7" }
const _hoisted_8 = {
  id: "kt_modal_update_role_form",
  class: "form",
  action: "#"
}
const _hoisted_9 = {
  class: "d-flex flex-column scroll-y me-n7 pe-7",
  id: "kt_modal_update_role_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_update_role_header",
  "data-kt-scroll-wrappers": "#kt_modal_update_role_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = { class: "fs-5 fw-bolder form-label mb-2" }
const _hoisted_12 = { class: "required" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-control form-control-solid",
  placeholder: "Enter a role name",
  name: "role_name",
  value: "Developer"
}, null, -1)
const _hoisted_14 = { class: "fv-row" }
const _hoisted_15 = { class: "fs-5 fw-bolder form-label mb-2" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_18 = { class: "text-gray-600 fw-bold" }
const _hoisted_19 = { class: "text-gray-800" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-1 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Allows a full access to the system"
}, null, -1)
const _hoisted_21 = { class: "form-check form-check-sm form-check-custom form-check-solid me-9" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  id: "kt_roles_select_all"
}, null, -1)
const _hoisted_23 = {
  class: "form-check-label",
  for: "kt_roles_select_all"
}
const _hoisted_24 = { class: "text-gray-800" }
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "user_management_read"
}, null, -1)
const _hoisted_28 = { class: "form-check-label" }
const _hoisted_29 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "user_management_write"
}, null, -1)
const _hoisted_31 = { class: "form-check-label" }
const _hoisted_32 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "user_management_create"
}, null, -1)
const _hoisted_34 = { class: "form-check-label" }
const _hoisted_35 = { class: "text-gray-800" }
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "content_management_read"
}, null, -1)
const _hoisted_39 = { class: "form-check-label" }
const _hoisted_40 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "content_management_write"
}, null, -1)
const _hoisted_42 = { class: "form-check-label" }
const _hoisted_43 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "content_management_create"
}, null, -1)
const _hoisted_45 = { class: "form-check-label" }
const _hoisted_46 = { class: "text-gray-800" }
const _hoisted_47 = { class: "d-flex" }
const _hoisted_48 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "financial_management_read"
}, null, -1)
const _hoisted_50 = { class: "form-check-label" }
const _hoisted_51 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "financial_management_write"
}, null, -1)
const _hoisted_53 = { class: "form-check-label" }
const _hoisted_54 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "financial_management_create"
}, null, -1)
const _hoisted_56 = { class: "form-check-label" }
const _hoisted_57 = { class: "text-gray-800" }
const _hoisted_58 = { class: "d-flex" }
const _hoisted_59 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "reporting_read"
}, null, -1)
const _hoisted_61 = { class: "form-check-label" }
const _hoisted_62 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "reporting_write"
}, null, -1)
const _hoisted_64 = { class: "form-check-label" }
const _hoisted_65 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "reporting_create"
}, null, -1)
const _hoisted_67 = { class: "form-check-label" }
const _hoisted_68 = { class: "text-gray-800" }
const _hoisted_69 = { class: "d-flex" }
const _hoisted_70 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "payroll_read"
}, null, -1)
const _hoisted_72 = { class: "form-check-label" }
const _hoisted_73 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "payroll_write"
}, null, -1)
const _hoisted_75 = { class: "form-check-label" }
const _hoisted_76 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "payroll_create"
}, null, -1)
const _hoisted_78 = { class: "form-check-label" }
const _hoisted_79 = { class: "text-gray-800" }
const _hoisted_80 = { class: "d-flex" }
const _hoisted_81 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "disputes_management_read"
}, null, -1)
const _hoisted_83 = { class: "form-check-label" }
const _hoisted_84 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "disputes_management_write"
}, null, -1)
const _hoisted_86 = { class: "form-check-label" }
const _hoisted_87 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "disputes_management_create"
}, null, -1)
const _hoisted_89 = { class: "form-check-label" }
const _hoisted_90 = { class: "text-gray-800" }
const _hoisted_91 = { class: "d-flex" }
const _hoisted_92 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "api_controls_read"
}, null, -1)
const _hoisted_94 = { class: "form-check-label" }
const _hoisted_95 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "api_controls_write"
}, null, -1)
const _hoisted_97 = { class: "form-check-label" }
const _hoisted_98 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "api_controls_create"
}, null, -1)
const _hoisted_100 = { class: "form-check-label" }
const _hoisted_101 = { class: "text-gray-800" }
const _hoisted_102 = { class: "d-flex" }
const _hoisted_103 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "database_management_read"
}, null, -1)
const _hoisted_105 = { class: "form-check-label" }
const _hoisted_106 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "database_management_write"
}, null, -1)
const _hoisted_108 = { class: "form-check-label" }
const _hoisted_109 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "database_management_create"
}, null, -1)
const _hoisted_111 = { class: "form-check-label" }
const _hoisted_112 = { class: "text-gray-800" }
const _hoisted_113 = { class: "d-flex" }
const _hoisted_114 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "repository_management_read"
}, null, -1)
const _hoisted_116 = { class: "form-check-label" }
const _hoisted_117 = { class: "form-check form-check-custom form-check-solid me-5 me-lg-20" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "repository_management_write"
}, null, -1)
const _hoisted_119 = { class: "form-check-label" }
const _hoisted_120 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  value: "",
  name: "repository_management_create"
}, null, -1)
const _hoisted_122 = { class: "form-check-label" }
const _hoisted_123 = { class: "text-center pt-15" }
const _hoisted_124 = {
  type: "reset",
  class: "btn btn-light me-3",
  "data-kt-roles-modal-action": "cancel"
}
const _hoisted_125 = {
  type: "submit",
  class: "btn btn-primary",
  "data-kt-roles-modal-action": "submit"
}
const _hoisted_126 = { class: "indicator-label" }
const _hoisted_127 = { class: "indicator-progress" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("updateRole")), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("roleName")), 1)
                ]),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("rolePermissions")), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("table", _hoisted_17, [
                    _createElementVNode("tbody", _hoisted_18, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_19, [
                          _createTextVNode(_toDisplayString(_ctx.$t("accessAdministrator")) + " ", 1),
                          _hoisted_20
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("label", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("selectAll")), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t("userManagement")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("label", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.$t("contentManagement")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("label", _hoisted_37, [
                              _hoisted_38,
                              _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_40, [
                              _hoisted_41,
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_43, [
                              _hoisted_44,
                              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.$t("financialManagement")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("label", _hoisted_48, [
                              _hoisted_49,
                              _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_51, [
                              _hoisted_52,
                              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_54, [
                              _hoisted_55,
                              _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.$t("reporting")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("label", _hoisted_59, [
                              _hoisted_60,
                              _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_62, [
                              _hoisted_63,
                              _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_65, [
                              _hoisted_66,
                              _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.$t("payroll")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("label", _hoisted_70, [
                              _hoisted_71,
                              _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_73, [
                              _hoisted_74,
                              _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_76, [
                              _hoisted_77,
                              _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.$t("disputesManagement")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("label", _hoisted_81, [
                              _hoisted_82,
                              _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_84, [
                              _hoisted_85,
                              _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_87, [
                              _hoisted_88,
                              _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_90, _toDisplayString(_ctx.$t("apiControls")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("label", _hoisted_92, [
                              _hoisted_93,
                              _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_95, [
                              _hoisted_96,
                              _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_98, [
                              _hoisted_99,
                              _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_101, _toDisplayString(_ctx.$t("dbManagement")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("label", _hoisted_103, [
                              _hoisted_104,
                              _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_106, [
                              _hoisted_107,
                              _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_109, [
                              _hoisted_110,
                              _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_112, _toDisplayString(_ctx.$t("repoManagement")), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("label", _hoisted_114, [
                              _hoisted_115,
                              _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.$t("read")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_117, [
                              _hoisted_118,
                              _createElementVNode("span", _hoisted_119, _toDisplayString(_ctx.$t("write")), 1)
                            ]),
                            _createElementVNode("label", _hoisted_120, [
                              _hoisted_121,
                              _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.$t("create")), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("button", _hoisted_124, _toDisplayString(_ctx.$t("discard")), 1),
              _createElementVNode("button", _hoisted_125, [
                _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.$t("submit")), 1),
                _createElementVNode("span", _hoisted_127, [
                  _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + "... ", 1),
                  _hoisted_128
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}